import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode"
import { EntityEnum } from "../../EntityEnum";
import { ROAEntityListView } from "../../../Data/MedicinalProductData/ROAEntityListView";
import { ROAAutoUploadEntity } from "../Entity/ROAAutoUploadEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { BaseNode } from "../../BaseNode";


export class TreeNodeMedicinalProductsROA extends SimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new ROAEntityListView(items), 'Routes of Administration', useHist ? EntityEnum.roaHist : EntityEnum.roa);
        this.useHist = useHist;
    }


    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${this.ioc!.get(LookupGetService).retrieveValueFromCache('type_Term', model.type_Term)} - ${model.ev_Code} - ${model.name_Admroute}`;
        return this.addChildNode(ROAAutoUploadEntity,labelTemplate, this,model, this.useHist, false, false);
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code','name_Admroute'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for routes of administration available in the XEVMPD [visibility restrictions may apply] including those owned by your HQ";
    }
}